import React, { useState } from 'react';
import maphatang from '../../assets/img/anh-ha-tang.png'
import hangmuc from '../../assets/img/vi-tri-hang-muc.png'
// hình ảnh trước bảo trì
import anh1 from '../../assets/road_images_clear_tach/road_01.png'
import anh2  from '../../assets/road_images_clear_tach/road_02.png'
import anh3 from '../../assets/road_images_clear_tach/road_03.png'
import anh4 from '../../assets/road_images_clear_tach/road_04.png'
import anh5 from '../../assets/road_images_clear_tach/road_05.png'
import anh6 from '../../assets/road_images_clear_tach/road_06.png'
//ảnh trong bảo trì
import anh7 from '../../assets/road_images_clear_tach/road_07.png'
import anh8 from '../../assets/road_images_clear_tach/road_08.png'
import anh9 from '../../assets/road_images_clear_tach/road_09.png'
import anh10 from '../../assets/road_images_clear_tach/road_10.png'
import anh11 from '../../assets/road_images_clear_tach/road_11.png'
import anh12 from '../../assets/road_images_clear_tach/road_12.png'
//anh sau bảo trì
import anh13 from '../../assets/road_images_clear_tach/road_image_1.png'
import anh14 from '../../assets/anh_tach_rieng1/sau_02.png'
import anh15 from '../../assets/road_images_clear_tach/road_image_3.png'
import anh16 from '../../assets/road_images_clear_tach/road_image_4.png'
import './HaTang.css'

function HaTang () {

        const [homeList, sethomeList] = useState("home");
     const [activetabList, setActivetabList] = useState("home");
     const [modal, setShowModal] = useState(false)
    //  const [detailInfrastructure, setDetailInfrastructure] = useState("detail-infrastructure")

    //  hàm mở modal thêm hạng mục
    const showModal = () => {
        setShowModal(true)
    }

    // hàm đóng modal
    const closeModal = () => {
        setShowModal(false)
    }


     //Hàm mở tab home
     const showHome = () => {
        sethomeList("home")
        setActivetabList("home")
     }

    //  hàm mở danh mục hạ tầng
     const showListInfrastructure = ()  => {
        sethomeList("infrastructure")
            setActivetabList("infrastructure")
     }


    //  Hàm khi bấm icon hình con mắt mở chi tiết danh mục hạ tầng
    const openShowDetailInfrastructure = () => {
        sethomeList("thong-tin-chung")
          setActivetabList("thong-tin-chung")

    }

    //hàm mở tab thông số kỹ thuật 
       const openThongSoKyThuat = () => {
        sethomeList("thong-so-ky-thuat")
          setActivetabList("thong-so-ky-thuat")

    }


        //hàm mở tab tài liệu 
       const openTaiLieu = () => {
        sethomeList("tai-lieu")
          setActivetabList("tai-lieu")

    }


          //hàm mở tab lịch sử bảo trì
       const openLichSuBaoTri= () => {
        sethomeList("lich-su-bao-tri")
          setActivetabList("lich-su-bao-tri")

    }


            //hàm mở tab hình ảnh
       const openHinhAnh= () => {
        sethomeList("hinh-anh")
          setActivetabList("hinh-anh")

    }





    //hàm quay lại danh sách bảng danh sách

    const backToListInfrastructure  = () => {
        sethomeList("infrastructure")
            setActivetabList("infrastructure")
    }


    //hàm quay lại lịch sử bảo trì
    const backToBaoTri = () => {
        sethomeList("lich-su-bao-tri")
          setActivetabList("lich-su-bao-tri")
    }
        return (
              <div className="hatang-page">

                {/* Breadcrumb */}
                <div className="hatang-breadcrumb">
                    <span className="hatang-breadcrumb-item">Trang chủ</span>
                    <span className="hatang-breadcrumb-arrow">›</span>
                    <span className="hatang-breadcrumb-current">Hạ tầng</span>
                </div>

                {/* Header */}
                <div className="hatang-header">
                    <div className="hatang-header-left">
                        {/* <h2 className="hatang-title">Hạ tầng</h2> */}

                        <div className="hatang-tabs">
                            <button 
                                  className={`hatang-tab ${
                    activetabList === "home"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={showHome}
                            >
                                Tổng quan
                            </button>

                            <button 
                             className={`hatang-tab ${
                    activetabList === "infrastructure"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={showListInfrastructure}
                            >
                                Danh mục hạ tầng
                            </button>
                        </div>
                    </div>

                    <div className="hatang-header-right">
                        <button className="hatang-btn">
                           <i class="fa-solid fa-arrow-down icon-hatang-share"></i>
                            Xuất báo cáo
                        </button>

                        <button className="hatang-btn">
                          <i class="fa-solid fa-filter icon-hatang-share"></i>
                            Bộ lọc
                        </button>
                    </div>
                </div>

                {/* Card thống kê */}
                <div className="hatang-overview-grid">

                    {/* Giao thông */}
                    <div className="hatang-overview-card">
                        <div className="hatang-overview-top">
                            <div className="hatang-icon hatang-purple">
                                <i className="fa-solid fa-road icon-road-fa"></i>
                            </div>

                            <div>
                                <div className="hatang-card-label">
                                    Giao thông
                                </div>

                                <div className="hatang-card-value">
                                    45,25 km
                                </div>
                            </div>
                        </div>

                        <div className="hatang-card-desc">
                            Tổng chiều dài đường
                        </div>

                        <div className="hatang-card-link">
                            Xem chi tiết →
                        </div>
                    </div>

                    {/* Điện */}
                    <div className="hatang-overview-card">
                        <div className="hatang-overview-top">
                            <div className="hatang-icon hatang-green">
                                ⚡
                            </div>

                            <div>
                                <div className="hatang-card-label">
                                    Điện
                                </div>

                                <div className="hatang-card-value">
                                    110 kV
                                </div>
                            </div>
                        </div>

                        <div className="hatang-card-desc">
                            Trạm biến áp chính
                        </div>

                        <div className="hatang-card-link">
                            Xem chi tiết →
                        </div>
                    </div>

                    {/* Nước sạch */}
                    <div className="hatang-overview-card">
                        <div className="hatang-overview-top">
                            <div className="hatang-icon hatang-blue">
                                💧
                            </div>

                            <div>
                                <div className="hatang-card-label">
                                    Nước sạch
                                </div>

                                <div className="hatang-card-value">
                                    10.000 m³/ngày
                                </div>
                            </div>
                        </div>

                        <div className="hatang-card-desc">
                            Công suất cấp nước
                        </div>

                        <div className="hatang-card-link">
                            Xem chi tiết →
                        </div>
                    </div>

                    {/* Nước thải */}
                    <div className="hatang-overview-card">
                        <div className="hatang-overview-top">
                            <div className="hatang-icon hatang-violet">
                                💧
                            </div>

                            <div>
                                <div className="hatang-card-label">
                                    Nước thải
                                </div>

                                <div className="hatang-card-value">
                                    8.000 m³/ngày
                                </div>
                            </div>
                        </div>

                        <div className="hatang-card-desc">
                            Công suất xử lý
                        </div>

                        <div className="hatang-card-link">
                            Xem chi tiết →
                        </div>
                    </div>

                    {/* Viễn thông */}
                    <div className="hatang-overview-card">
                        <div className="hatang-overview-top">
                            <div className="hatang-icon hatang-yellow">
                                📡
                            </div>

                            <div>
                                <div className="hatang-card-label">
                                    Viễn thông
                                </div>

                                <div className="hatang-card-value">
                                    100%
                                </div>
                            </div>
                        </div>

                        <div className="hatang-card-desc">
                            Phủ sóng trong KCN
                        </div>

                        <div className="hatang-card-link">
                            Xem chi tiết →
                        </div>
                    </div>
                </div>

                {/* Map + biểu đồ */}
                <div className="hatang-middle-grid">

                    {/* Bản đồ */}
                    <div className="hatang-map-card">
                        <div className="hatang-section-title">
                            Bản đồ hạ tầng kỹ thuật
                        </div>

                        <div className="hatang-map-wrapper">

                            {/* Chú thích */}
                            <div className="hatang-map-legend">
                                <div className="hatang-legend-title">
                                    Chú thích
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-road"></span>
                                    Đường giao thông
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-electric"></span>
                                    Điện trung thế
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-water"></span>
                                    Điện hạ thế
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-clean-water"></span>
                                    Cấp nước sạch
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-drain"></span>
                                    Thoát nước mưa
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-waste"></span>
                                    Thoát nước thải
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-fire"></span>
                                    PCCC
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-telecom"></span>
                                    Viễn thông
                                </div>

                                <div className="hatang-legend-item">
                                    <span className="hatang-legend-line hatang-light"></span>
                                    Chiếu sáng
                                </div>
                            </div>

                            {/* Map */}
                            <div className="hatang-map-area">
                               
                                <img
                                    src={maphatang}
                                    alt=""
                                    className="hatang-map-image"
                                />
                                 <button className='icon-zoomm'>⤢</button>

                                <div className="hatang-map-tools">
                                    <button className='icon-plusss'>
                                        <i className="fa-solid fa-plus"></i>
                                    </button>
                                    <button className='icon-minusss'>
                                        <i className="fa-solid fa-minus"></i>
                                    </button>
                                    <button className='icon-layer'>
                                        <i className="fa-solid fa-layer-group"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Trạng thái */}
                    <div className="hatang-status-card">
                        <div className="hatang-section-title">
                            Tình trạng hạ tầng
                        </div>

                        <div className="hatang-status-content">

                            {/* Circle */}
                            <div className="hatang-circle-chart">
                                <div className="hatang-circle-inner">
                                    <span className="hatang-circle-total">
                                        Tổng số
                                    </span>

                                    <span className="hatang-circle-number">
                                        09
                                    </span>

                                    <span className="hatang-circle-total">
                                        hạng mục
                                    </span>
                                </div>
                            </div>

                            {/* Legend */}
                           <div className="hatang-status-list">
    <table className="table-status-action">
        <thead>
            <tr>
                <th className="status-one">Trạng thái</th>
                <th className="status-two">Số hạng mục</th>
                <th className="status-three">Tỷ lệ</th>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td className="hatang-status-col-1">
                    <div className="hatang-status-label">
                        <span className="hatang-dot hatang-dot-green"></span>
                        <span>Đang hoạt động tốt</span>
                    </div>
                </td>

                <td className="hatang-status-col-2">
                    6
                </td>

                <td className="hatang-status-col-3">
                    66,67%
                </td>
            </tr>

            <tr>
                <td className="hatang-status-col-1">
                    <div className="hatang-status-label">
                        <span className="hatang-dot hatang-dot-purple"></span>
                        <span>Đang hoạt động</span>
                    </div>
                </td>

                <td className="hatang-status-col-2">
                    2
                </td>

                <td className="hatang-status-col-3">
                    22,22%
                </td>
            </tr>

            <tr>
                <td className="hatang-status-col-1">
                    <div className="hatang-status-label">
                        <span className="hatang-dot hatang-dot-yellow"></span>
                        <span>Quá tải</span>
                    </div>
                </td>

                <td className="hatang-status-col-2">
                    1
                </td>

                <td className="hatang-status-col-3">
                    11,11%
                </td>
            </tr>

            <tr>
                <td className="hatang-status-col-1">
                    <div className="hatang-status-label">
                        <span className="hatang-dot hatang-dot-red"></span>
                        <span>Ngừng hoạt động</span>
                    </div>
                </td>

                <td className="hatang-status-col-2">
                    0
                </td>

                <td className="hatang-status-col-3">
                    0%
                </td>
            </tr>
        </tbody>
    </table>
</div>
                        </div>

                        <div className="hatang-card-link hatang-status-link">
                            Xem chi tiết tình trạng →
                        </div>
                    </div>
                </div>

                {/* Bottom grid */}
                <div className="hatang-bottom-grid">

                    {/* Danh sách hạng mục */}
                    <div className="hatang-table-card">

                        <div className="hatang-section-title">
                            Danh sách hạng mục hạ tầng
                        </div>

                        <div className="hatang-table-wrapper">
                            <table className="hatang-table">
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Hạng mục</th>
                                        <th>Quy mô / Công suất</th>
                                        <th>Đơn vị quản lý</th>
                                        <th>Tình trạng</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Đường giao thông</td>
                                        <td>45,25 km</td>
                                        <td>Ban QL KKT An Giang</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>2</td>
                                        <td>Điện trung thế</td>
                                        <td>110 kV</td>
                                        <td>Điện lực An Giang</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td>Điện hạ thế</td>
                                        <td>22 kV</td>
                                        <td>Điện lực An Giang</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>4</td>
                                        <td>Cấp nước sạch</td>
                                        <td>10.000 m³/ngày</td>
                                        <td>Công ty CP Cấp nước AG</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>5</td>
                                        <td>Thoát nước mưa</td>
                                        <td>Hệ thống riêng</td>
                                        <td>Ban QL KKT An Giang</td>
                                        <td>
                                            <span className="hatang-badge yellow">
                                                Quá tải
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>6</td>
                                        <td>Thoát nước thải</td>
                                        <td>8.000 m³/ngày</td>
                                        <td>Công ty CP Môi trường AG</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>7</td>
                                        <td>PCCC</td>
                                        <td>Hệ thống đầy đủ</td>
                                        <td>Ban QL KKT An Giang</td>
                                        <td>
                                            <span className="hatang-badge blue">
                                                Đang hoạt động
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>8</td>
                                        <td>Viễn thông</td>
                                        <td>100% phủ sóng</td>
                                        <td>VNPT An Giang</td>
                                        <td>
                                            <span className="hatang-badge blue">
                                                Đang hoạt động
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>9</td>
                                        <td>Chiếu sáng</td>
                                        <td>Hệ thống LED</td>
                                        <td>Ban QL KKT An Giang</td>
                                        <td>
                                            <span className="hatang-badge green">
                                                Đang hoạt động tốt
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <button className="hatang-view-all">
                            Xem tất cả →
                        </button>
                    </div>

                    {/* Cảnh báo */}
                    <div className="hatang-alert-card">

                        <div className="hatang-section-title">
                            Cảnh báo hạ tầng
                        </div>

                        <div className="hatang-table-wrapper">
                            <table className="hatang-table">
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Hạng mục</th>
                                        <th>Nội dung cảnh báo</th>
                                        <th>Mức độ</th>
                                        <th>Thời gian</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Thoát nước thải</td>
                                        <td>
                                            Công suất xử lý đạt 95% công suất thiết kế
                                        </td>
                                        <td>
                                            <span className="hatang-alert high">
                                                Cao
                                            </span>
                                        </td>
                                        <td>12/05/2026 08:30</td>
                                    </tr>

                                    <tr>
                                        <td>2</td>
                                        <td>Trạm biến áp 110kV</td>
                                        <td>
                                            Tải trạm TBA 110kV hiện đạt 92%
                                        </td>
                                        <td>
                                            <span className="hatang-alert medium">
                                                Trung bình
                                            </span>
                                        </td>
                                        <td>12/05/2026 07:45</td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td>Đường giao thông N2</td>
                                        <td>
                                            Mật độ lưu lượng xe lớn &gt; 5000 lượt/ngày cao
                                        </td>
                                        <td>
                                            <span className="hatang-alert medium">
                                                Trung bình
                                            </span>
                                        </td>
                                        <td>11/05/2026 16:20</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <button className="hatang-view-all">
                            Xem tất cả cảnh báo →
                        </button>
                    </div>
                </div>










                {/* Danh mục hạ tầng */}
                    <div
                     className={
                    homeList === "infrastructure"
                        ? "list-infrastructure-overlay-show"
                        : "list-infrastructure-overlay-hide"
                }
                    >

     <div className="list-hatang-container">

        {/* breadcrumb */}
        <div className="list-hatang-breadcrumb">
            <span className="list-hatang-breadcrumb-text">Trang chủ</span>
            <span className="list-hatang-breadcrumb-dot">›</span>
            <span className="list-hatang-breadcrumb-text">Hạ tầng</span>
            <span className="list-hatang-breadcrumb-dot">›</span>
            <span className="list-hatang-breadcrumb-active">Danh mục hạ tầng</span>
        </div>

        {/* header */}
        <div className="list-hatang-header">
            <div className="list-hatang-header-left">
                <h2 className="list-hatang-title">
                    Danh mục hạ tầng
                </h2>

                <p className="list-hatang-description">
                    Quản lý và theo dõi toàn bộ các hạng mục hạ tầng kỹ thuật trong KCN
                </p>
            </div>

            <div className="list-hatang-header-right">
                <button className="list-hatang-export-btn">
                    <i className="fa-solid fa-arrow-down icon-pad-right"></i>
                    Xuất Excel
                </button>

                <button className="list-hatang-filter-btn">
                    <i className="fa-solid fa-filter icon-pad-right"></i>
                    Bộ lọc
                </button>

                <button className="list-hatang-add-btn"
                onClick={showModal}
                >
                    + Thêm hạng mục
                </button>
            </div>
        </div>

        {/* statistic cards */}
        <div className="list-hatang-card-wrapper">

            <div className="list-hatang-card">
                <div className="list-hatang-card-icon purple">
                    🛣
                </div>

                <div className="list-hatang-card-content">
                    <p className="list-hatang-card-title">Giao thông</p>
                    <h3 className="list-hatang-card-value">45,25 km</h3>
                    <p className="list-hatang-card-sub">
                        Đường giao thông
                    </p>

                    <span className="list-hatang-card-link">
                        Xem chi tiết →
                    </span>
                </div>
            </div>

            <div className="list-hatang-card">
                <div className="list-hatang-card-icon green">
                    ⚡
                </div>

                <div className="list-hatang-card-content">
                    <p className="list-hatang-card-title">Điện</p>
                    <h3 className="list-hatang-card-value">110 kV</h3>
                    <p className="list-hatang-card-sub">
                        Trạm biến áp chính
                    </p>

                    <span className="list-hatang-card-link">
                        Xem chi tiết →
                    </span>
                </div>
            </div>

            <div className="list-hatang-card">
                <div className="list-hatang-card-icon blue">
                    💧
                </div>

                <div className="list-hatang-card-content">
                    <p className="list-hatang-card-title">Nước sạch</p>
                    <h3 className="list-hatang-card-value">10.000 m³/ngày</h3>
                    <p className="list-hatang-card-sub">
                        Công suất cấp nước
                    </p>

                    <span className="list-hatang-card-link">
                        Xem chi tiết →
                    </span>
                </div>
            </div>

            <div className="list-hatang-card">
                <div className="list-hatang-card-icon pink">
                    💧
                </div>

                <div className="list-hatang-card-content">
                    <p className="list-hatang-card-title">Nước thải</p>
                    <h3 className="list-hatang-card-value">8.000 m³/ngày</h3>
                    <p className="list-hatang-card-sub">
                        Công suất xử lý
                    </p>

                    <span className="list-hatang-card-link">
                        Xem chi tiết →
                    </span>
                </div>
            </div>

            <div className="list-hatang-card">
                <div className="list-hatang-card-icon yellow">
                    📡
                </div>

                <div className="list-hatang-card-content">
                    <p className="list-hatang-card-title">Viễn thông</p>
                    <h3 className="list-hatang-card-value">100%</h3>
                    <p className="list-hatang-card-sub">
                        Phủ sóng trong KCN
                    </p>

                    <span className="list-hatang-card-link">
                        Xem chi tiết →
                    </span>
                </div>
            </div>

        </div>

        {/* tabs */}
        <div className="list-hatang-tab-wrapper">

            <div className="list-hatang-tabs">
                <button className="list-hatang-tab-btn" onClick={showHome}>
                    Tổng quan
                </button>

                <button className="list-hatang-tab-btn active">
                    Danh mục hạ tầng
                </button>
            </div>

            <div className="list-hatang-filter-group">

                <span className='hatang-hang-muc'>Hạng mục</span>
                 <select className="list-hatang-select">
                    <option>Tất cả</option>
                </select>

                <span className='hatang-trang-thai'>Trạng thái</span>
                <select className="list-hatang-select">
                    <option>Tất cả</option>
                </select>

                <div className="list-hatang-search-box">
                    <input
                        type="text"
                        placeholder="Tìm kiếm hạng mục..."
                        className="list-hatang-search-input"
                    />

                    <span className="list-hatang-search-icon">
                        🔍
                    </span>
                </div>
            </div>
        </div>

        {/* table */}
        <div className="list-hatang-table-wrapper">

            <table className="list-hatang-table">

                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Hạng mục</th>
                        <th>Loại hạ tầng</th>
                        <th>Quy mô / Thông số</th>
                        <th>Đơn vị quản lý</th>
                        <th>Trạng thái</th>
                        <th>Vị trí</th>
                        <th>Ngày cập nhật</th>
                        <th>Thao tác</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>1</td>
                        <td >
                              <div className='duong-giao-thong' >
                                {/* <div>
                                <i className="fa-solid fa-road icon-road-solidd"></i>
                              </div> */}
                         <div>
                               <div className="list-hatang-item-title">
                              
                                Đường giao thông
                            </div>
                            <div className="list-hatang-item-sub">
                                Đường nội bộ chính
                            </div>
                         </div>
                              </div>
                        </td>
                        <td className="purple-text">Giao thông</td>
                        <td>
                            Tổng chiều dài: 45,25 km <br />
                            Mặt cắt: 4-6 làn xe
                        </td>
                        <td>Ban QL KKT An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>12/05/2026 08:30</td>
                        <td>
                            <i className="fa-regular fa-eye icon-eye-hatang"
                            onClick={openShowDetailInfrastructure}
                            ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Trạm biến áp 110kV
                            </div>
                            <div className="list-hatang-item-sub">
                                Trạm điện áp chính
                            </div>
                        </td>
                        <td className="green-text">Điện</td>
                        <td>
                            Công suất: 2x63 MVA <br />
                            Điện áp: 110/22kV
                        </td>
                        <td>Điện lực An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>12/05/2026 07:45</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Đường dây 22kV
                            </div>
                            <div className="list-hatang-item-sub">
                                Đường dây trung thế
                            </div>
                        </td>
                        <td className="green-text">Điện</td>
                        <td>
                            Tổng chiều dài: 22,10 km <br />
                            Điện áp: 22kV
                        </td>
                        <td>Điện lực An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>11/05/2026 16:20</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Hệ thống cấp nước
                            </div>
                            <div className="list-hatang-item-sub">
                                Nhà máy nước
                            </div>
                        </td>
                        <td className="blue-text">Nước sạch</td>
                        <td>
                            Công suất: 10.000 m³/ngày <br />
                            Đường ống: D300-D800
                        </td>
                        <td>Công ty CP Cấp nước AG</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>12/05/2026 09:10</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Trạm xử lý nước thải
                            </div>
                            <div className="list-hatang-item-sub">
                                Nhà máy xử lý
                            </div>
                        </td>
                        <td className="pink-text">Nước thải</td>
                        <td>
                            Công suất: 8.000 m³/ngày <br />
                            Công nghệ: AAO
                        </td>
                        <td>Công ty CP Môi trường AG</td>
                        <td>
                            <span className="list-hatang-status warning-status">
                                Quá tải
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>12/05/2026 09:00</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>6</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Hệ thống thu gom NT
                            </div>
                            <div className="list-hatang-item-sub">
                                Đường ống thu gom
                            </div>
                        </td>
                        <td className="pink-text">Nước thải</td>
                        <td>
                            Tổng chiều dài: 18,60 km <br />
                            Đường ống: D200-D600
                        </td>
                        <td>Công ty CP Môi trường AG</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>11/05/2026 14:35</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>7</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Mạng viễn thông
                            </div>
                            <div className="list-hatang-item-sub">
                                Cáp quang
                            </div>
                        </td>
                        <td className="yellow-text">Viễn thông</td>
                        <td>
                            Tổng chiều dài: 30,50 km <br />
                            Băng thông: 10Gbps
                        </td>
                        <td>VNPT An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>10/05/2026 10:15</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>8</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Chiếu sáng công cộng
                            </div>
                            <div className="list-hatang-item-sub">
                                Hệ thống chiếu sáng
                            </div>
                        </td>
                        <td className="orange-text">Chiếu sáng</td>
                        <td>
                            Số lượng: 1.250 đèn LED <br />
                            Công suất: 150W
                        </td>
                        <td>Ban QL KKT An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>10/05/2026 09:20</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>9</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Hệ thống PCCC
                            </div>
                            <div className="list-hatang-item-sub">
                                Trụ nước, bể nước
                            </div>
                        </td>
                        <td className="red-text">PCCC</td>
                        <td>
                            Số trụ: 120 trụ <br />
                            Dung tích bể: 5.000 m³
                        </td>
                        <td>Ban QL KKT An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>09/05/2026 15:40</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                    <tr>
                        <td>10</td>
                        <td>
                            <div className="list-hatang-item-title">
                                Hệ thống thoát nước mưa
                            </div>
                            <div className="list-hatang-item-sub">
                                Mương, cống thoát
                            </div>
                        </td>
                        <td className="gray-text">Thoát nước mưa</td>
                        <td>
                            Tổng chiều dài: 25,80 km <br />
                            Kích thước: B600-B2000
                        </td>
                        <td>Ban QL KKT An Giang</td>
                        <td>
                            <span className="list-hatang-status active-status">
                                Đang hoạt động tốt
                            </span>
                        </td>
                        <td>KCN Bình Hòa</td>
                        <td>09/05/2026 11:05</td>
                        <td>
                             <i className="fa-regular fa-eye icon-eye-hatang"
                              onClick={openShowDetailInfrastructure}
                             ></i>
                            <i className="fa-solid fa-pen icon-pen-hatang"></i>
                            <i className="fa-solid fa-ellipsis-vertical icon-menu-hatang"></i>
                        </td>
                    </tr>

                </tbody>

            </table>

            {/* footer */}
            <div className="list-hatang-table-footer">

                <div className="list-hatang-footer-left">
                    Hiển thị 1 - 10 trong tổng số 23 hạng mục
                </div>

                <div className="list-hatang-pagination">

                    <select className="list-hatang-page-select">
                        <option>10 / trang</option>
                    </select>

                    <button className="list-hatang-page-btn active">
                        1
                    </button>

                    <button className="list-hatang-page-btn">
                        2
                    </button>

                    <button className="list-hatang-page-btn">
                        3
                    </button>

                </div>
            </div>

        </div>
    </div>








{/* Vùng modal */}
<div
    className={
        modal
            ? "list-modal-hatang-overlay list-modal-hatang-overlay-show"
            : "list-modal-hatang-overlay"
    }
>
    <div className="list-modal-hatang-container">

        {/* Header */}
        <div className="list-modal-hatang-header">
            <div>
                <h2 className="list-modal-hatang-title">
                    Thêm hạng mục hạ tầng
                </h2>
            </div>

            <button
                className="list-modal-hatang-close"
                onClick={closeModal}
            >
                ×
            </button>
        </div>

        {/* Body */}
        <div className="list-modal-hatang-body">

            {/* Hạng mục */}
            <div className="list-modal-hatang-group">
                <label className="list-modal-hatang-label">
                    Hạng mục <span>*</span>
                </label>

                <select className="list-modal-hatang-select">
                    <option>Chọn hạng mục</option>
                    <option>Đường giao thông</option>
                    <option>Điện</option>
                    <option>Nước sạch</option>
                    <option>Nước thải</option>
                    <option>Viễn thông</option>
                </select>
            </div>

            {/* Loại hạ tầng */}
            <div className="list-modal-hatang-group">
                <label className="list-modal-hatang-label">
                    Loại hạ tầng <span>*</span>
                </label>

                <select className="list-modal-hatang-select">
                    <option>Chọn loại hạ tầng</option>
                    <option>Giao thông</option>
                    <option>Điện</option>
                    <option>Nước sạch</option>
                    <option>Nước thải</option>
                    <option>Viễn thông</option>
                </select>
            </div>

            {/* Đơn vị quản lý + vị trí */}
            <div className="list-modal-hatang-row">

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Đơn vị quản lý <span>*</span>
                    </label>

                    <select className="list-modal-hatang-select">
                        <option>Chọn đơn vị quản lý</option>
                        <option>Ban QL KKT</option>
                        <option>VNPT</option>
                        <option>Công ty điện lực</option>
                    </select>
                </div>

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Vị trí <span>*</span>
                    </label>

                    <input
                        type="text"
                        className="list-modal-hatang-input"
                        placeholder="Nhập vị trí"
                    />
                </div>

            </div>

            {/* Thông số kỹ thuật */}
            <div className="list-modal-hatang-group">
                <label className="list-modal-hatang-label">
                    Thông số kỹ thuật
                </label>

                {/* <textarea
                    className="list-modal-hatang-textarea"
                    placeholder="Nhập quy mô, thông số kỹ thuật..."
                /> */}
            </div>

            {/* Quy mô */}
            <div className="list-modal-hatang-group">
                <label className="list-modal-hatang-label">
                    Quy mô / Thông số <span>*</span>
                </label>

                <textarea
                    className="list-modal-hatang-textarea"
                    placeholder="Nhập quy mô, thông số kỹ thuật..."
                />
            </div>

            {/* Đơn vị tính + số lượng */}
            <div className="list-modal-hatang-row">

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Đơn vị tính
                    </label>

                    <select className="list-modal-hatang-select">
                        <option>Chọn đơn vị tính</option>
                        <option>Km</option>
                        <option>m²</option>
                        <option>m³</option>
                    </select>
                </div>

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Số lượng / Giá trị
                    </label>

                    <input
                        type="text"
                        className="list-modal-hatang-input"
                        placeholder="Nhập số lượng hoặc giá trị"
                    />
                </div>

            </div>

            {/* Trạng thái + ngày */}
            <div className="list-modal-hatang-row">

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Trạng thái <span>*</span>
                    </label>

                    <select className="list-modal-hatang-select">
                        <option>Chọn trạng thái</option>
                        <option>Đang hoạt động tốt</option>
                        <option>Quá tải</option>
                        <option>Bảo trì</option>
                    </select>
                </div>

                <div className="list-modal-hatang-group">
                    <label className="list-modal-hatang-label">
                        Ngày đưa vào vận hành
                    </label>

                    <input
                        type="date"
                        className="list-modal-hatang-input"
                    />
                </div>

            </div>

            {/* Ghi chú */}
            <div className="list-modal-hatang-group">
                <label className="list-modal-hatang-label">
                    Ghi chú
                </label>

                <textarea
                    className="list-modal-hatang-textarea"
                    placeholder="Nhập ghi chú nếu có..."
                />
            </div>

        </div>

        {/* Footer */}
        <div className="list-modal-hatang-footer">

            <button
                className="list-modal-hatang-btn-cancel"
                onClick={closeModal}
            >
                Hủy
            </button>

            <button className="list-modal-hatang-btn-save">
                Lưu
            </button>

        </div>

    </div>
</div>

{/* Vùng modal */}








                    </div>
                
                {/* Danh mục hạ tầng */}































                {/* Chi tiết danh mục hạ tầng */}
                    <div 
                    className={
                    homeList === "thong-tin-chung"
                        ? "detail-ha-tang-overlay-show"
                        : "detail-ha-tang-overlay-hide"
                }>

            
          <div className="detail-ha-tang-container">

            {/* ===== Breadcrumb ===== */}
            <div className="detail-ha-tang-breadcrumb">
                <span>Trang chủ</span>
                <span>›</span>
                <span>Hạ tầng</span>
                <span>›</span>
                <span>Danh mục hạ tầng</span>
                <span>›</span>
                <span>Chi tiết hạng mục</span>
            </div>

            {/* ===== Header ===== */}
            <div className="detail-ha-tang-header">
                <div className='detail-ha-tang-header-wraper'>
                    <h1 className="detail-ha-tang-title">
                        Chi tiết hạng mục hạ tầng
                    </h1>

                    <div className="detail-ha-tang-status">
                        Đang hoạt động tốt
                    </div>
                </div>

                <div className="detail-ha-tang-header-actions">
                    <button className="detail-ha-tang-btn-outline">
                        <i className="fa-solid fa-pen icon-pen-out"></i>
                        Chỉnh sửa
                    </button>

                    <button className="detail-ha-tang-btn-outline" onClick={backToListInfrastructure}>
                        ↩ Quay lại
                    </button>
                </div>
            </div>

            {/* ===== Top Content ===== */}
            <div className="detail-ha-tang-top-grid">

                {/* ===== Left Info ===== */}
                <div className="detail-ha-tang-card-left">

                    <div className="detail-ha-tang-main-info">

                        <div className="detail-ha-tang-icon">
                            🛣
                        </div>

                        <div>
                            <h2 className="detail-ha-tang-name">
                                Đường giao thông
                            </h2>

                            <p className="detail-ha-tang-sub">
                                Đường nội bộ chính
                            </p>
                        </div>
                    </div>

                    <div className="detail-ha-tang-info-grid">

                        <div className="detail-ha-tang-info-item">
                            <label>Mã hạng mục</label>
                            <span>HTGT-GT-001</span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Loại hạ tầng</label>
                            <span>Giao thông</span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Đơn vị quản lý</label>
                            <span>Ban QL KKT An Giang</span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Vị trí</label>
                            <span>KCN Bình Hòa</span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Ngày đưa vào vận hành</label>
                            <span>12/05/2021</span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Trạng thái</label>
                            <span className="detail-ha-tang-active-text">
                                Đang hoạt động tốt
                            </span>
                        </div>

                        <div className="detail-ha-tang-info-item">
                            <label>Ngày cập nhật</label>
                            <span>12/05/2026 08:30</span>
                        </div>

                    </div>
                </div>

                {/* ===== Map ===== */}
                <div className="detail-ha-tang-card">

                    <div className="detail-ha-tang-map-title">
                        Vị trí hạng mục
                    </div>

                    <div className="detail-ha-tang-map">
                        <img
                            src={hangmuc}
                            alt=""
                            className='hang-muc-img-detail'
                        />

                        <div className="detail-ha-tang-map-label">
                            <strong>Đường giao thông</strong>
                            <span>Đường nội bộ chính</span>
                        </div>
                         <button className='btn-fa-solid-fa-expand'><i className="fa-solid fa-expand"></i></button>

                        <div className="detail-ha-tang-map-actions">
                            <button><i className="fa-solid fa-plus"></i></button>
                            <button><i className="fa-solid fa-minus"></i></button>
                            
                           
                        </div>
                        <button className='btn-fa-layer-group'><i className="fa-solid fa-layer-group"></i></button>
                    </div>

                    <div className="detail-ha-tang-map-footer">
                        <span>Tọa độ: 10.455678, 105.397891</span>

                        <a href="/">
                            Xem trên bản đồ lớn →
                        </a>
                    </div>
                </div>

            </div>

            {/* ===== Tabs ===== */}
            {/* className="detail-ha-tang-tab active" */}
            <div className="detail-ha-tang-tabs">
                <button 
                 className={`detail-ha-tang-tab ${
                    activetabList === "thong-tin-chung"
                        ? "detail-ha-tang-tab-active"
                        : ""
                }`}
                          
                
                
                            type="button"
                            onClick={openShowDetailInfrastructure}
                >
                    Thông tin chung
                </button>

                <button 
                 className={`detail-ha-tang-tab ${
                    activetabList === "thong-so-ky-thuat"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openThongSoKyThuat}
                >
                    Thông số kỹ thuật
                </button>

                <button 
                className={`detail-ha-tang-tab ${
                    activetabList === "tai-lieu"
                        ? "tai-lieu-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openTaiLieu}
                
                >
                    Tài liệu
                </button>

                <button 
                className={`detail-ha-tang-tab ${
                    activetabList === "lich-su-bao-tri"
                        ? "lich-su-bao-tri-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openLichSuBaoTri}
                >
                    Lịch sử bảo trì
                </button>

                <button 
                 className={`detail-ha-tang-tab ${
                    activetabList === "hinh-anh"
                        ? "hinh-anh-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openHinhAnh}
                >
                    Hình ảnh
                </button>
            </div>

            {/* ===== Bottom Grid ===== */}
            <div className="detail-ha-tang-bottom-grid">

                {/* ===== Left Column ===== */}
                <div className="detail-ha-tang-left-column">

                    {/* ===== Thông tin chung ===== */}
                    <div className="detail-ha-tang-card">

                        <h3 className="detail-ha-tang-section-title">
                            Thông tin chung
                        </h3>

                        <div className="detail-ha-tang-detail-grid">

                            <div className="detail-ha-tang-detail-item">
                                <label>Quy mô / Chiều dài</label>
                                <span>45,25 km</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Mặt cắt ngang</label>
                                <span>4 - 6 làn xe</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Bề rộng mặt đường</label>
                                <span>24 m</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Kết cấu mặt đường</label>
                                <span>Bê tông nhựa nóng</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Hệ thống thoát nước</label>
                                <span>Có</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Chiếu sáng</label>
                                <span>Có hệ thống LED</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Biển báo, sơn kẻ</label>
                                <span>Đầy đủ</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Ghi chú</label>
                                <span>-</span>
                            </div>

                        </div>
                    </div>

                    

                    {/* ===== Tuyến đường ===== */}
                    <div className="detail-ha-tang-card">

                        <div className="detail-ha-tang-table-header">
                            <div>
                                <h3 className="detail-ha-tang-section-title">
                                    Tuyến đường
                                </h3>

                                <p>
                                    Danh sách các tuyến thuộc hạng mục đường giao thông
                                </p>
                            </div>
                        </div>

                        <div className="detail-ha-tang-table-wrapper">

                            <table className="detail-ha-tang-table">

                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên tuyến</th>
                                        <th>Điểm đầu</th>
                                        <th>Chiều dài (km)</th>
                                        <th>Số làn xe</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr>
                                        <td>1</td>
                                        <td>Đoạn 1</td>
                                        <td>Cổng chính KCN</td>
                                        <td>12,50</td>
                                        <td>6</td>
                                    </tr>

                                    <tr>
                                        <td>2</td>
                                        <td>Đoạn 2</td>
                                        <td>Nút giao đường N1</td>
                                        <td>15,75</td>
                                        <td>4</td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td>Đoạn 3</td>
                                        <td>Nút giao đường N3</td>
                                        <td>9,00</td>
                                        <td>4</td>
                                    </tr>

                                    <tr>
                                        <td>4</td>
                                        <td>Cầu số 2</td>
                                        <td>Ranh giới KCN</td>
                                        <td>8,00</td>
                                        <td>4</td>
                                    </tr>

                                </tbody>

                            </table>
                        </div>

                        <a
                            href="/"
                            className="detail-ha-tang-link"
                        >
                            Xem chi tiết tuyến đường →
                        </a>
                    </div>
                </div>

                {/* ===== Middle Column ===== */}
                <div className="detail-ha-tang-middle-column">

                    {/* ===== Technical ===== */}
                    <div className="detail-ha-tang-card">

                        <h3 className="detail-ha-tang-section-title">
                            Thông số kỹ thuật
                        </h3>

                        <div className="detail-ha-tang-detail-grid">

                            <div className="detail-ha-tang-detail-item">
                                <label>Tổng chiều dài</label>
                                <span>45,25 km</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Bề rộng nền đường</label>
                                <span>30 m</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Bề rộng mặt đường</label>
                                <span>24 m</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Số làn xe</label>
                                <span>4 - 6 làn</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Tải trọng thiết kế</label>
                                <span>Trục 10 tấn</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Kết cấu áo đường</label>
                                <span>Bê tông nhựa nóng</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Hệ thống thoát nước</label>
                                <span>Dọc tuyến, cống hộp</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Hệ thống chiếu sáng</label>
                                <span>Đèn LED 150W, khoảng cách 35m</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Hệ thống an toàn giao thông</label>
                                <span>Biển báo, sơn kẻ, gờ giảm tốc</span>
                            </div>

                            <div className="detail-ha-tang-detail-item">
                                <label>Tình trạng hiện tại</label>
                                <span>Tốt (Đánh giá 12/05/2026)</span>
                            </div>

                        </div>
                    </div>

                    {/* ===== Pie Chart ===== */}
                    <div className="detail-ha-tang-card">

                        <div className="detail-ha-tang-chart-header">
                            <h3 className="detail-ha-tang-section-title">
                                Hiện trạng sử dụng
                            </h3>
                        </div>

                        <div className="detail-ha-tang-chart-wrapper">

                            <div className="detail-ha-tang-pie-chart">

                                <div className="detail-ha-tang-pie-center">
                                    <span className='plus-km'>Tổng chiều dài</span>
                                    <strong>45,25</strong>
                                    <span className='km'>km</span>
                                </div>

                            </div>

                            <div className="detail-ha-tang-chart-legend">

                                <div className="detail-ha-tang-legend-item">
                                    <span className="green"></span>
                                    Đang sử dụng tốt
                                    <br/>
                                  42,10 km  (93,04%)
                                </div>

                                <div className="detail-ha-tang-legend-item">
                                    <span className="yellow"></span>
                                    Cần bảo trì
                                    <br/>
                                    2,45 km (5,42%)
                                </div>

                                <div className="detail-ha-tang-legend-item">
                                    <span className="red"></span>
                                    Đang sửa chữa
                                    <br/>
                                    0,70 km (1,54%)
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* ===== Right Column ===== */}
                <div className="detail-ha-tang-right-column">

                    {/* ===== Rating ===== */}
                    <div className="detail-ha-tang-card">

                        <h3 className="detail-ha-tang-section-title">
                            Tình trạng & đánh giá
                        </h3>

                        <div className="detail-ha-tang-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star-half-stroke"></i>
                            {/* ⭐ ⭐ ⭐ ⭐ ☆ */}
                            <span>4.5/5</span>
                        </div>

                        <div className="detail-ha-tang-review-grid">

                            <div className="detail-ha-tang-review-grid-below">
                                <label >Ngày đánh giá gần nhất: </label>
                                <span className='return-left'>12/05/2026</span>
                            </div>

                            <div className="detail-ha-tang-review-grid-below">
                                <label>Đơn vị đánh giá: </label>
                                <span>Ban QL KKT 
                                    <br/>
                                    An Giang</span>
                            </div>

                            <div className="detail-ha-tang-review-grid-below">
                                <label >Chu kỳ đánh giá: </label>
                                <span  className='return-left'>6 tháng/lần</span>
                            </div>

                        </div>
                    </div>

                    {/* ===== Maintenance ===== */}
                    <div className="detail-ha-tang-card">

                        <h3 className="detail-ha-tang-section-title">
                            Bảo trì gần nhất
                        </h3>

                        <div className="detail-ha-tang-maintenance">

                            <div>
                                <label>Ngày bảo trì: </label>
                                <span>15/04/2026</span>
                            </div>

                            <div>
                                <label>Nội dung: </label>
                                <span>
                                    Bảo trì định kỳ mặt đường, sơn kẻ,
                                    <br/>
                                    vệ sinh hệ thống thoát nước
                                </span>
                            </div>

                            <div>
                                <label>Đơn vị 
                                    
                                    thực hiện: </label>
                                <span className='return-left'>
                                    Công ty CP Đầu tư & Phát triển 
                                   <br/>
                                    Hạ tầng AG
                                </span>
                            </div>

                        </div>

                        <a href="/" className="detail-ha-tang-link">
                            Xem lịch sử bảo trì →
                        </a>
                    </div>

                    {/* ===== Files ===== */}
                    <div className="detail-ha-tang-card">

                        <h3 className="detail-ha-tang-section-title">
                            Tài liệu liên quan
                        </h3>

                        <div className="detail-ha-tang-files">

                            <div className="detail-ha-tang-file-item">
                                <span><i className="fa-regular fa-file-pdf icon-pdf-ha-tang"></i>
                                    Bản vẽ hoàn công.pdf</span>
                                <button>⬇</button>
                            </div>

                            <div className="detail-ha-tang-file-item">
                                <span><i className="fa-regular fa-file-pdf icon-pdf-ha-tang"></i> Hồ sơ kỹ thuật.pdf</span>
                                <button>⬇</button>
                            </div>

                            <div className="detail-ha-tang-file-item">
                                <span><i className="fa-regular fa-file-pdf icon-pdf-ha-tang"></i>Quy trình vận hành.pdf</span>
                                <button>⬇</button>
                            </div>

                        </div>

                        <a href="/" className="detail-ha-tang-link">
                            Xem tất cả tài liệu →
                        </a>
                    </div>

                </div>

            </div>

        </div>
                    </div>

                {/* Chi tiết dạnh mục hạ tầng */}





























                {/* Thông số kỹ thuật */}
                <div 
                className={
                    homeList === "thong-so-ky-thuat"
                        ? "detail-thong-so-ky-thuat-overlay-show"
                        : "detail-thong-so-ky-thuat-overlay-hide"
                }
                >

                    <div className="thong-so-ky-thuat-wrapper">
    {/* Breadcrumb */}
    <div className="thong-so-ky-thuat-breadcrumb">
        <span>Trang chủ</span>
        <span>›</span>
        <span>Hạ tầng</span>
        <span>›</span>
        <span>Danh mục hạ tầng</span>
        <span>›</span>
        <span>Chi tiết hạng mục</span>
        <span>›</span>
        <span className="thong-so-ky-thuat-breadcrumb-active">Thông số kỹ thuật</span>
    </div>

    {/* Header */}
    <div className="thong-so-ky-thuat-header">
        <div>
            <h1 className="thong-so-ky-thuat-title">
                Thông số kỹ thuật
            </h1>

            <div className="thong-so-ky-thuat-back" onClick={openShowDetailInfrastructure}>
                <i className="fa-solid fa-arrow-left icon-thong-so-back"></i>
                Quay lại chi tiết hạng mục
            </div>
        </div>

        <button className="thong-so-ky-thuat-pdf-btn">
            Xuất PDF
        </button>
    </div>

    {/* Overview Card */}
    <div className="thong-so-ky-thuat-overview-card">

        {/* Left */}
        <div className="thong-so-ky-thuat-overview-left">

            <div className="thong-so-ky-thuat-icon">
                🛣
            </div>

            <div className="thong-so-ky-thuat-overview-info">
                <h2>Đường giao thông</h2>

                <p>Đường nội bộ chính</p>

                <span className="thong-so-ky-thuat-status">
                    Đang hoạt động tốt
                </span>
            </div>
        </div>

        {/* Right */}
        <div className="thong-so-ky-thuat-overview-right">

            <div className="thong-so-ky-thuat-info-grid">

                <div className="thong-so-ky-thuat-info-item">
                    <label>Mã hạng mục</label>
                    <span>HTHT-GT-001</span>
                </div>

                <div className="thong-so-ky-thuat-info-item">
                    <label>Vị trí</label>
                    <span>KCN Bình Hòa</span>
                </div>

                <div className="thong-so-ky-thuat-info-item">
                    <label>Loại hạ tầng</label>
                    <span>Giao thông</span>
                </div>

                <div className="thong-so-ky-thuat-info-item">
                    <label>Ngày đưa vào vận hành</label>
                    <span>12/05/2021</span>
                </div>

                <div className="thong-so-ky-thuat-info-item">
                    <label>Đơn vị quản lý</label>
                    <span>Ban QL KKT An Giang</span>
                </div>

                <div className="thong-so-ky-thuat-info-item">
                    <label>Ngày cập nhật</label>
                    <span>12/05/2026 08:30</span>
                </div>

            </div>

        </div>

    </div>

    {/* Tabs */}
    <div className="thong-so-ky-thuat-tabs">
        <button 
         className={`thong-so-ky-thuat-tab ${
                    activetabList === "thong-tin-chung"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openShowDetailInfrastructure}
        >Thông tin chung</button>

        <button 
         className={`thong-so-ky-thuat-tab ${
                    activetabList === "thong-so-ky-thuat"
                        ? "thong-so-ky-thuat-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openThongSoKyThuat}
        >
            Thông số kỹ thuật
        </button>

        <button
        
         className={`thong-so-ky-thuat-tab ${
                    activetabList === "tai-lieu"
                        ? "tai-lieu-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openTaiLieu}
        >Tài liệu</button>

        <button
          className={`thong-so-ky-thuat-tab ${
                    activetabList === "lich-su-bao-tri"
                        ? "lich-su-bao-tri-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openLichSuBaoTri}
        
        >Lịch sử bảo trì</button>

        <button
           className={`thong-so-ky-thuat-tab ${
                    activetabList === "hinh-anh"
                        ? "hinh-anh-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openHinhAnh}
        
        >Hình ảnh</button>
    </div>

    {/* Content */}
    <div className="thong-so-ky-thuat-content">

        {/* Block 1 */}
        <div className="thong-so-ky-thuat-card">

            <h3>
                1. Thông số chung
            </h3>

            <div className="thong-so-ky-thuat-detail-list">

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Quy mô / Chiều dài</span>
                    <strong>45,25 km</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Mặt cắt ngang</span>
                    <strong>4 – 6 làn xe</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Bề rộng nền đường</span>
                    <strong>30 m</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Bề rộng mặt đường</span>
                    <strong>24 m</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Kết cấu mặt đường</span>
                    <strong>Bê tông nhựa nóng</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Hệ thống thoát nước</span>
                    <strong>Có</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Chiếu sáng</span>
                    <strong>Có (Hệ thống LED)</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Biển báo, sơn kẻ</span>
                    <strong>Đầy đủ</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Hệ thống an toàn giao thông</span>
                    <strong>
                        Biển báo, sơn kẻ, gờ giảm tốc
                    </strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Tình trạng hiện tại</span>
                    <strong>
                        Tốt (Đánh giá 12/05/2026)
                    </strong>
                </div>

            </div>

        </div>

        {/* Block 2 */}
        <div className="thong-so-ky-thuat-card">

            <h3>
                2. Thông số kỹ thuật chi tiết
            </h3>

            {/* Road Structure */}
            <div className="thong-so-ky-thuat-subtitle">
                ⛓ Kết cấu áo đường
            </div>

            <table className="thong-so-ky-thuat-table">

                <thead>
                    <tr>
                        <th>Lớp cấu tạo</th>
                        <th>Vật liệu</th>
                        <th>Bề dày (cm)</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>Lớp mặt</td>
                        <td>Bê tông nhựa nóng (AC16)</td>
                        <td>5</td>
                    </tr>

                    <tr>
                        <td>Lớp liên kết</td>
                        <td>Bê tông nhựa nóng (AC22)</td>
                        <td>7</td>
                    </tr>

                    <tr>
                        <td>Lớp base</td>
                        <td>Cấp phối đá dăm loại I</td>
                        <td>18</td>
                    </tr>

                    <tr>
                        <td>Lớp subbase</td>
                        <td>Cát đầm chặt K≥0.95</td>
                        <td>20</td>
                    </tr>

                    <tr>
                        <td>Nền đường</td>
                        <td>Đất đầm chặt K≥0.95</td>
                        <td>—</td>
                    </tr>

                </tbody>

            </table>

            {/* Drainage */}
            <div className="thong-so-ky-thuat-subtitle margin-top">
                ∿ Hệ thống thoát nước
            </div>

            <div className="thong-so-ky-thuat-detail-list">

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Loại hệ thống</span>
                    <strong>Thoát nước mưa riêng</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Hệ thống cống dọc</span>
                    <strong>Bê tông cốt thép D600 – D1200</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Hệ thống cống ngang</span>
                    <strong>Bê tông cốt thép D800 – D1500</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Khoảng cách hố ga</span>
                    <strong>25 – 30 m</strong>
                </div>

            </div>

        </div>

        {/* Block 3 */}
        <div className="thong-so-ky-thuat-card">

            <h3>
                3. Thông số thiết kế
            </h3>

            <div className="thong-so-ky-thuat-detail-list">

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Tiêu chuẩn áp dụng</span>
                    <strong>
                        TCVN 4054:2005, TCVN 4054:2005/AMD1:2011,
                        22TCN 211-06
                    </strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Tốc độ thiết kế</span>
                    <strong>60 km/h</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Tải trọng thiết kế</span>
                    <strong>Trục 10 tấn</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Số làn xe</span>
                    <strong>4 – 6 làn</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Hướng tuyến</span>
                    <strong>
                        Tuyến thẳng, có các nút giao thông nội bộ
                    </strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Bán kính đường cong nhỏ nhất</span>
                    <strong>200 m</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Độ dốc dọc lớn nhất</span>
                    <strong>3%</strong>
                </div>

                <div className="thong-so-ky-thuat-detail-item">
                    <span>Độ dốc ngang</span>
                    <strong>2%</strong>
                </div>

            </div>

        </div>

        {/* Block 4 */}
        <div className="thong-so-ky-thuat-card">

            <h3>
                4. Ghi chú
            </h3>

            <ul className="thong-so-ky-thuat-note-list">

                <li>
                    <i className="fa-solid fa-circle icon-note-list"></i>
                    Thông số được cập nhật lần cuối vào ngày
                    12/05/2026.
                </li>

                <li>
                    <i className="fa-solid fa-circle icon-note-list"></i>
                    Hạng mục được kiểm tra định kỳ 6 tháng/lần.
                </li>

                <li>
                    <i className="fa-solid fa-circle icon-note-list"></i>
                    Mọi thay đổi thông số sẽ được cập nhật trong
                    lịch sử bảo trì.
                </li>

            </ul>

        </div>

    </div>

</div>

                </div>

                {/* Thông số kỹ thuật */}


















                {/* Tài liệu */}
                <div 
                className={
                    homeList === "tai-lieu"
                        ? "detail-tai-lieu-overlay-show"
                        : "detail-tai-lieu-overlay-hide"
                }
                >
                     

                     <div className="detail-tai-lieu-wrapper">

        {/* Breadcrumb */}
        <div className="detail-tai-lieu-breadcrumb">
            <span className="detail-tai-lieu-breadcrumb-item">Trang chủ</span>
            <span className="detail-tai-lieu-breadcrumb-arrow">›</span>

            <span className="detail-tai-lieu-breadcrumb-item">Hạ tầng</span>
            <span className="detail-tai-lieu-breadcrumb-arrow">›</span>

            <span className="detail-tai-lieu-breadcrumb-item">Danh mục hạ tầng</span>
            <span className="detail-tai-lieu-breadcrumb-arrow">›</span>

            <span className="detail-tai-lieu-breadcrumb-item">Chi tiết hạng mục</span>
            <span className="detail-tai-lieu-breadcrumb-arrow">›</span>

            <span className="detail-tai-lieu-breadcrumb-active">Tài liệu</span>
        </div>

        {/* Header */}
        <div className="detail-tai-lieu-header">
            <div>
                <h2 className="detail-tai-lieu-page-title">Tài liệu</h2>

                <div className="detail-tai-lieu-back" onClick={backToListInfrastructure}>
                   <i className="fa-solid fa-arrow-left icon-tai-lieu-back"></i>
                    Quay lại chi tiết hạng mục
                </div>
            </div>

            <button className="detail-tai-lieu-export-btn">
                ⬇ Xuất danh sách
            </button>
        </div>

        {/* Info Card */}
        <div className="detail-tai-lieu-info-card">

            <div className="detail-tai-lieu-info-left">
                <div className="detail-tai-lieu-road-icon">
                    🛣
                </div>

                <div>
                    <h3 className="detail-tai-lieu-road-title">
                        Đường giao thông
                    </h3>

                    <p className="detail-tai-lieu-road-desc">
                        Đường nội bộ chính
                    </p>

                    <span className="detail-tai-lieu-status">
                        Đang hoạt động tốt
                    </span>
                </div>
            </div>

            <div className="detail-tai-lieu-info-grid">

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Mã hạng mục
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        HTHT-GT-001
                    </span>
                </div>

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Vị trí
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        KCN Bình Hòa
                    </span>
                </div>

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Loại hạ tầng
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        Giao thông
                    </span>
                </div>

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Ngày đưa vào vận hành
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        12/05/2021
                    </span>
                </div>

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Đơn vị quản lý
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        Ban QL KKT An Giang
                    </span>
                </div>

                <div className="detail-tai-lieu-info-item">
                    <span className="detail-tai-lieu-info-label">
                        Ngày cập nhật
                    </span>

                    <span className="detail-tai-lieu-info-value">
                        12/05/2026 08:30
                    </span>
                </div>

            </div>

        </div>

        {/* Tabs */}
        <div className="detail-tai-lieu-tabs">
            <div 
            className={`detail-tai-lieu-tab-item ${
                    activetabList === "thong-tin-chung"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                           
                            onClick={openShowDetailInfrastructure}

            >
                Thông tin chung
            </div>

            <div 
            className={`detail-tai-lieu-tab-item ${
                    activetabList === "thong-so-ky-thuat"
                        ? "thong-so-ky-thuat-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openThongSoKyThuat}
            >
                Thông số kỹ thuật
            </div>

                    {/* className="detail-tai-lieu-tab-item detail-tai-lieu-tab-active" */}
            <div 
            className={`detail-tai-lieu-tab-item ${
                    activetabList === "tai-lieu"
                        ? "tai-lieu-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openTaiLieu}
            >
                Tài liệu
            </div>

            <div 
            className={`detail-tai-lieu-tab-item ${
                    activetabList === "lich-su-bao-tri"
                        ? "lich-su-bao-tri-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openLichSuBaoTri}
            >
                Lịch sử bảo trì
            </div>

            <div 
             className={`detail-tai-lieu-tab-item ${
                    activetabList === "hinh-anh"
                        ? "hinh-anh-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openHinhAnh}
            
            >
                Hình ảnh
            </div>
        </div>

        {/* Toolbar */}
        <div className="detail-tai-lieu-toolbar">

            <h3 className="detail-tai-lieu-section-title">
                Danh sách tài liệu
            </h3>

            <div className="detail-tai-lieu-toolbar-right">

                <select className="detail-tai-lieu-select">
                    <option>Tất cả loại tài liệu</option>
                </select>

                <div className="detail-tai-lieu-search-box">
                    <input
                        type="text"
                        placeholder="Tìm kiếm tài liệu..."
                        className="detail-tai-lieu-search-input"
                    />

                    <span className="detail-tai-lieu-search-icon">
                        🔍
                    </span>
                </div>

            </div>

        </div>

        {/* Table */}
        <div className="detail-tai-lieu-table-wrapper">

            <table className="detail-tai-lieu-table">

                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Tên tài liệu</th>
                        <th>Loại tài liệu</th>
                        <th>Mô tả</th>
                        <th>Phiên bản</th>
                        <th>Dung lượng</th>
                        <th>Ngày tải lên</th>
                        <th>Người tải lên</th>
                        <th>Thao tác</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>1</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📕 Bản vẽ hoàn công.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-green">
                                Bản vẽ
                            </span>
                        </td>

                        <td>Bản vẽ hoàn công đường nội bộ chính</td>
                        <td>V1.0</td>
                        <td>2.45 MB</td>
                        <td>12/05/2026 08:30</td>
                        <td>Nguyễn Văn A</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                               <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                                {/* 👁  ⬇  ⋮ */}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📘 Hồ sơ kỹ thuật.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-blue">
                                Hồ sơ kỹ thuật
                            </span>
                        </td>

                        <td>Hồ sơ kỹ thuật đường nội bộ chính</td>
                        <td>V1.0</td>
                        <td>3.12 MB</td>
                        <td>12/05/2026 08:25</td>
                        <td>Nguyễn Văn A</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                               <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📙 Thuyết minh thiết kế.pptx
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-purple">
                                Thuyết minh
                            </span>
                        </td>

                        <td>Thuyết minh thiết kế công trình</td>
                        <td>V1.0</td>
                        <td>4.18 MB</td>
                        <td>12/05/2026 08:20</td>
                        <td>Trần Thị B</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                               <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📕 Quy trình vận hành, khai thác.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-cyan">
                                Quy trình
                            </span>
                        </td>

                        <td>Quy trình vận hành và khai thác</td>
                        <td>V1.0</td>
                        <td>1.85 MB</td>
                        <td>12/05/2026 08:15</td>
                        <td>Trần Thị B</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                                <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📗 Bảng tính khối lượng.xlsx
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-lime">
                                Bảng tính
                            </span>
                        </td>

                        <td>Bảng tính khối lượng công trình</td>
                        <td>V1.0</td>
                        <td>0.98 MB</td>
                        <td>12/05/2026 08:10</td>
                        <td>Lê Văn C</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                                <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>6</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📘 Báo cáo nghiệm thu.docx
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-yellow">
                                Báo cáo
                            </span>
                        </td>

                        <td>Báo cáo nghiệm thu hoàn thành</td>
                        <td>V1.0</td>
                        <td>1.25 MB</td>
                        <td>12/05/2026 08:05</td>
                        <td>Lê Văn C</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                                <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>7</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📕 Giấy phép xây dựng.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-red">
                                Pháp lý
                            </span>
                        </td>

                        <td>Giấy phép xây dựng công trình</td>
                        <td>V1.0</td>
                        <td>0.65 MB</td>
                        <td>12/05/2026 07:55</td>
                        <td>Phạm Văn D</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                 <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                               <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>8</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📕 Biên bản nghiệm thu PCCC.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-orange">
                                Nghiệm thu
                            </span>
                        </td>

                        <td>Biên bản nghiệm thu PCCC</td>
                        <td>V1.0</td>
                        <td>0.72 MB</td>
                        <td>12/05/2026 07:50</td>
                        <td>Phạm Văn D</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                  <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                               <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>9</td>

                        <td>
                            <div className="detail-tai-lieu-file-name">
                                📕 Tài liệu khác.pdf
                            </div>
                        </td>

                        <td>
                            <span className="detail-tai-lieu-tag detail-tai-lieu-tag-gray">
                                Khác
                            </span>
                        </td>

                        <td>Các tài liệu liên quan khác</td>
                        <td>V1.0</td>
                        <td>1.10 MB</td>
                        <td>12/05/2026 07:45</td>
                        <td>Nguyễn Văn A</td>

                        <td>
                            <div className="detail-tai-lieu-action">
                                  <i className="fa-regular fa-eye icon-tai-lieu-right"></i>
                                <i className="fa-solid fa-arrow-down icon-tai-lieu-center"></i>
                                <i className="fa-solid fa-ellipsis-vertical icon-tai-lieu-left"></i>
                            </div>
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>

        {/* Footer */}
        <div className="detail-tai-lieu-footer">

            <div className="detail-tai-lieu-footer-text">
                Hiển thị 1 - 9 trong tổng số 9 tài liệu
            </div>

            <div className="detail-tai-lieu-pagination">

                <select className="detail-tai-lieu-page-select">
                    <option>10 / trang</option>
                </select>

                <button className="detail-tai-lieu-page-btn">
                    ‹
                </button>

                <button className="detail-tai-lieu-page-btn detail-tai-lieu-page-active">
                    1
                </button>

                <button className="detail-tai-lieu-page-btn">
                    ›
                </button>

            </div>

        </div>

    </div>



                </div>

                {/* Tài Liệu */}



















                {/* Lịch sử bảo trì */}
                <div
                className={
                    homeList === "lich-su-bao-tri"
                        ? "detail-lich-su-bao-tri-show"
                        : "detail-lich-su-bao-tri-overlay-hide"
                }
                
                >

                      <div className="lich-su-bao-tri-wrapper">

                {/* Breadcrumb */}
                <div className="lich-su-bao-tri-breadcrumb">
                    <span>Trang chủ</span>
                    <span className="lich-su-bao-tri-dot">›</span>

                    <span>Hạ tầng</span>
                    <span className="lich-su-bao-tri-dot">›</span>

                    <span>Danh mục hạ tầng</span>
                    <span className="lich-su-bao-tri-dot">›</span>

                    <span>Chi tiết hạng mục</span>
                    <span className="lich-su-bao-tri-dot">›</span>

                    <span className="lich-su-bao-tri-active-page">
                        Lịch sử bảo trì
                    </span>
                </div>

                {/* Page Title */}
                <div className="lich-su-bao-tri-page-header">

                    <h1 className="lich-su-bao-tri-title">
                        Lịch sử bảo trì
                    </h1>

                    <button className="lich-su-bao-tri-back-btn" onClick={backToListInfrastructure}>
                        ← Quay lại chi tiết hạng mục
                    </button>
                </div>

                {/* Info Card */}
                <div className="lich-su-bao-tri-info-card">

                    <div className="lich-su-bao-tri-info-left">

                        <div className="lich-su-bao-tri-icon-box">
                               🛣
                            {/* 🛣️ */}
                        </div>

                        <div className="lich-su-bao-tri-main-info">

                            <h2>Đường giao thông</h2>

                            <p>Đường nội bộ chính</p>

                            <span className="lich-su-bao-tri-status-success">
                                Đang hoạt động tốt
                            </span>

                        </div>
                    </div>

                    <div className="lich-su-bao-tri-info-right">

                        <div className="lich-su-bao-tri-info-grid">

                            <div className="lich-su-bao-tri-info-item">
                                <label>Mã hạng mục</label>
                                <span>HTHT-GT-001</span>
                            </div>

                            <div className="lich-su-bao-tri-info-item">
                                <label>Vị trí</label>
                                <span>KCN Bình Hòa</span>
                            </div>

                            <div className="lich-su-bao-tri-info-item">
                                <label>Loại hạ tầng</label>
                                <span>Giao thông</span>
                            </div>

                            <div className="lich-su-bao-tri-info-item">
                                <label>Ngày đưa vào vận hành</label>
                                <span>12/05/2021</span>
                            </div>

                            <div className="lich-su-bao-tri-info-item">
                                <label>Đơn vị quản lý</label>
                                <span>Ban QL KKT An Giang</span>
                            </div>

                            <div className="lich-su-bao-tri-info-item">
                                <label>Ngày cập nhật</label>
                                <span>12/05/2026 08:30</span>
                            </div>

                        </div>

                    </div>

                </div>

                {/* Tabs */}
                <div className="lich-su-bao-tri-tabs">

                    <button 
                    className={`lich-su-bao-tri-tab-btn ${
                    activetabList === "thong-tin-chung"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openShowDetailInfrastructure}


                    >
                        Thông tin chung
                    </button>

                    <button 
                         className={`lich-su-bao-tri-tab-btn ${
                    activetabList === "thong-so-ky-thuat"
                        ? "thong-so-ky-thuat-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openThongSoKyThuat}
                    >
                        Thông số kỹ thuật
                    </button>

                    <button 
                    
                             className={`lich-su-bao-tri-tab-btn ${
                    activetabList === "tai-lieu"
                        ? "tai-lieu-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openTaiLieu}
                    >
                        Tài liệu
                    </button>

                    <button 
                     className={`lich-su-bao-tri-tab-btn ${
                    activetabList === "lich-su-bao-tri"
                        ? "lich-su-bao-tri-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openLichSuBaoTri}
                    >
                        Lịch sử bảo trì
                    </button>

                    <button 
                     className={`lich-su-bao-tri-tab-btn ${
                    activetabList === "hinh-anh"
                        ? "hinh-anh-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openHinhAnh}
                    >
                        Hình ảnh
                    </button>

                </div>

                {/* Filter */}
                <div className="lich-su-bao-tri-filter-wrapper">

                    <div className="lich-su-bao-tri-filter-left">

                        <select className="lich-su-bao-tri-select">
                            <option>Tất cả trạng thái</option>
                        </select>

                        <div className="lich-su-bao-tri-date-box">
                            <input
                                type="date"
                                className="lich-su-bao-tri-date-input"
                            />
                        </div>

                        <div className="lich-su-bao-tri-date-box">
                            <input
                                type="date"
                                className="lich-su-bao-tri-date-input"
                            />
                        </div>

                    </div>

                    <div className="lich-su-bao-tri-filter-right">

                        <div className="lich-su-bao-tri-search-box">

                            <input
                                type="text"
                                placeholder="Tìm kiếm nội dung bảo trì..."
                                className="lich-su-bao-tri-search-input"
                            />

                            <button className="lich-su-bao-tri-search-btn">
                                🔍
                            </button>

                        </div>

                        <button className="lich-su-bao-tri-export-btn">
                            ⬇ Xuất Excel
                        </button>

                    </div>

                </div>

                {/* Table */}
                <div className="lich-su-bao-tri-table-wrapper">

                    <table className="lich-su-bao-tri-table">

                        <thead>

                            <tr>

                                <th>STT</th>
                                <th>Mã bảo trì</th>
                                <th>Nội dung bảo trì</th>
                                <th>Loại bảo trì</th>
                                <th>Đơn vị thực hiện</th>
                                <th>Ngày bắt đầu</th>
                                <th>Ngày hoàn thành</th>
                                <th>Chi phí (VND)</th>
                                <th>Trạng thái</th>
                                <th>Hành động</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>1</td>
                                <td>BT-GT-2026-0009</td>
                                <td>
                                    Sửa chữa mặt đường đoạn Km1-
                                    200 đến Km1+600
                                </td>
                                <td>Sửa chữa</td>
                                <td>Công ty CP Xây dựng An Giang</td>
                                <td>05/05/2026</td>
                                <td>10/05/2026</td>
                                <td>128.500.000</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-success">
                                        Đã hoàn thành
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>2</td>
                                <td>BT-GT-2026-0007</td>
                                <td>
                                    Vệ sinh hệ thống thoát nước dọc tuyến
                                </td>
                                <td>Vệ sinh</td>
                                <td>Công ty TNHH Môi trường Xanh AG</td>
                                <td>11/04/2026</td>
                                <td>19/04/2026</td>
                                <td>15.800.000</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-success">
                                        Đã hoàn thành
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>3</td>
                                <td>BT-GT-2026-0005</td>
                                <td>
                                    Sơn lại vạch đường, biển báo giao thông
                                </td>
                                <td>Bảo dưỡng</td>
                                <td>Công ty CP Hạ tầng Giao thông AG</td>
                                <td>02/04/2026</td>
                                <td>04/04/2026</td>
                                <td>32.600.000</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-success">
                                        Đã hoàn thành
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>4</td>
                                <td>BT-GT-2026-0003</td>
                                <td>
                                    Kiểm tra, bảo dưỡng hệ thống chiếu sáng
                                </td>
                                <td>Bảo dưỡng</td>
                                <td>Công ty Điện lực An Giang</td>
                                <td>15/03/2026</td>
                                <td>16/03/2026</td>
                                <td>29.900.000</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-success">
                                        Đã hoàn thành
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>5</td>
                                <td>BT-GT-2026-0001</td>
                                <td>
                                    Khắc phục ổ gà, nứt mặt đường
                                </td>
                                <td>Sửa chữa</td>
                                <td>Công ty CP Xây dựng An Giang</td>
                                <td>01/03/2026</td>
                                <td>05/03/2026</td>
                                <td>86.750.000</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-success">
                                        Đã hoàn thành
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>6</td>
                                <td>BT-GT-2026-0010</td>
                                <td>
                                    Sửa chữa rãnh thoát nước hư hỏng
                                </td>
                                <td>Sửa chữa</td>
                                <td>Công ty TNHH Môi trường Xanh AG</td>
                                <td>20/05/2026</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-warning">
                                        Đang thực hiện
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>7</td>
                                <td>BT-GT-2026-0012</td>
                                <td>
                                    Bảo dưỡng định kỳ hệ thống chiếu sáng
                                </td>
                                <td>Bảo dưỡng</td>
                                <td>Công ty Điện lực An Giang</td>
                                <td>25/05/2026</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-warning">
                                        Đang thực hiện
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>8</td>
                                <td>BT-GT-2026-0013</td>
                                <td>
                                    Kiểm tra, đánh giá hiện trạng mặt đường
                                </td>
                                <td>Kiểm tra</td>
                                <td>Ban QL KKT An Giang</td>
                                <td>28/05/2026</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                    <span className="lich-su-bao-tri-badge-plan">
                                        Kế hoạch
                                    </span>
                                </td>
                                <td>
                                    <div className="lich-su-bao-tri-action-group">
                                        <button>👁</button>
                                        <button>⬇</button>
                                    </div>
                                </td>
                            </tr>

                        </tbody>

                    </table>

                </div>

                {/* Footer */}
                <div className="lich-su-bao-tri-footer">

                    <p>
                        Hiển thị 1 - 8 trong tổng số 8 bản ghi
                    </p>

                    <div className="lich-su-bao-tri-pagination">
                        <select className="lich-su-bao-tri-page-select">
                    <option>10 / trang</option>
                </select>

                        <button>‹</button>

                        <button className="lich-su-bao-tri-page-active">
                            1
                        </button>

                        <button>›</button>

                    </div>

                </div>

            </div>

                </div>

                {/* Lịch sử bảo trì */}

















                {/* Hình ảnh */}
                    <div
                    className={
                    homeList === "hinh-anh"
                        ? "detail-hinh-anh-overlay-show"
                        : "detail-hinh-anh-overlay-hide"
                }
                    
                    >


                        <div className="hinh-anh-container">

            {/* Breadcrumb */}
            <div className="hinh-anh-breadcrumb">
                <span>Trang chủ</span>
                <span>›</span>
                <span>Hạ tầng</span>
                <span>›</span>
                <span>Danh mục hạ tầng</span>
                <span>›</span>
                <span>Chi tiết hạng mục</span>
                <span>›</span>
                <span>Lịch sử bảo trì</span>
                <span>›</span>
                <span className="hinh-anh-current">Hình ảnh</span>
            </div>

            {/* Title */}
            <div className="hinh-anh-page-title">
                <h2>Hình ảnh</h2>
            </div>

            {/* Back */}
            <div className="hinh-anh-back" onClick={backToBaoTri}>
                <i className="fa-solid fa-arrow-left icon-back-bao-tri"></i>
                 Quay lại lịch sử bảo trì
            </div>

            {/* Info Card */}
            <div className="hinh-anh-info-card">

                <div className="hinh-anh-info-left">

                    <div className="hinh-anh-road-icon">
                        🛣
                    </div>

                    <div className="hinh-anh-road-content">
                        <h3>Đường giao thông</h3>
                        <p>Đường nội bộ chính</p>

                        <div className="hinh-anh-status">
                            Đã hoàn thành
                        </div>
                    </div>

                </div>

                <div className="hinh-anh-info-right">

                    <div className="hinh-anh-info-grid">

                        <div className="hinh-anh-info-item">
                            <span>Mã bảo trì</span>
                            <strong>BT-GT-2026-0009</strong>
                        </div>

                        <div className="hinh-anh-info-item">
                            <span>Đơn vị thực hiện</span>
                            <strong>Công ty CP Xây dựng An Giang</strong>
                        </div>

                        <div className="hinh-anh-info-item">
                            <span>Nội dung bảo trì</span>
                            <strong>Sửa chữa mặt đường đoạn Km1+200 đến Km1+600</strong>
                        </div>

                        <div className="hinh-anh-info-item">
                            <span>Ngày bắt đầu</span>
                            <strong>05/05/2026</strong>
                        </div>

                        <div className="hinh-anh-info-item">
                            <span>Loại bảo trì</span>
                            <strong>Sửa chữa</strong>
                        </div>

                        <div className="hinh-anh-info-item">
                            <span>Ngày hoàn thành</span>
                            <strong>10/05/2026</strong>
                        </div>

                    </div>

                </div>

            </div>

            {/* Tabs */}
            <div className="hinh-anh-tabs">

                <div 
                className={`hinh-anh-tab-item ${
                    activetabList === "thong-tin-chung"
                        ? "hatang-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openShowDetailInfrastructure}
                
                
                >
                    Thông tin chung
                </div>

                <div 
                  className={`hinh-anh-tab-item ${
                    activetabList === "thong-so-ky-thuat"
                        ? "thong-so-ky-thuat-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openThongSoKyThuat}
                >
                    Thông số kỹ thuật
                </div>

                <div 
                 className={`hinh-anh-tab-item ${
                    activetabList === "tai-lieu"
                        ? "tai-lieu-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openTaiLieu}
                >
                    Tài liệu
                </div>

                <div 
                 className={`hinh-anh-tab-item ${
                    activetabList === "lich-su-bao-tri"
                        ? "lich-su-bao-tri-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openLichSuBaoTri}
                >
                    Lịch sử bảo trì
                </div>

                <div 
                 className={`hinh-anh-tab-item ${
                    activetabList === "hinh-anh"
                        ? "hinh-anh-tab-active"
                        : ""
                }`}
                            
                            type="button"
                            onClick={openHinhAnh}
                >
                    Hình ảnh
                </div>

            </div>

            {/* Filter */}
            <div className="hinh-anh-filter-wrapper">

                <div className="hinh-anh-filter-left">

                    <button className="hinh-anh-filter-btn hinh-anh-filter-active">
                        Tất cả (18)
                    </button>

                    <button className="hinh-anh-filter-btn">
                        Trước bảo trì (6)
                    </button>

                    <button className="hinh-anh-filter-btn">
                        Trong quá trình (8)
                    </button>

                    <button className="hinh-anh-filter-btn">
                        Sau bảo trì (4)
                    </button>

                </div>

                         <button className="hinh-anh-filter-btn">
                         ⬇ Tải tất cả
                    </button>
                {/* <div className="hinh-anh-download">
                    ⬇ Tải tất cả
                </div> */}

            </div>

            {/* Trước bảo trì */}
            <div className="hinh-anh-section">

                <div className="hinh-anh-section-title">
                    <span className="hinh-anh-dot-purple"></span>
                    Trước bảo trì (6 ảnh)
                </div>

                <div className="hinh-anh-card-wrapper">

                    {/* Card 1 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh1}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_01.jpg</h5>
                            <p>05/05/2026 08:15</p>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh2}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_02.jpg</h5>
                            <p>05/05/2026 08:16</p>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh3}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_03.jpg</h5>
                            <p>05/05/2026 08:17</p>
                        </div>
                    </div>

                    {/* Card 4 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh4}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_04.jpg</h5>
                            <p>05/05/2026 08:18</p>
                        </div>
                    </div>

                    {/* Card 5 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh5}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_05.jpg</h5>
                            <p>05/05/2026 08:19</p>
                        </div>
                    </div>

                    {/* Card 6 */}
                    <div className="hinh-anh-card">
                        <img
                            src={anh6}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>truoc_06.jpg</h5>
                            <p>05/05/2026 08:20</p>
                        </div>
                    </div>

                </div>

            </div>

            {/* Trong quá trình */}
            <div className="hinh-anh-section">

                <div className="hinh-anh-section-title">
                    <span className="hinh-anh-dot-orange"></span>
                    Trong quá trình (8 ảnh)
                </div>

                <div className="hinh-anh-card-wrapper">

                    <div className="hinh-anh-card">
                        <img
                            src={anh7}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_01.jpg</h5>
                            <p>06/05/2026 09:10</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh8}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_02.jpg</h5>
                            <p>06/05/2026 10:20</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh9}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_03.jpg</h5>
                            <p>07/05/2026 08:45</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh10}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_04.jpg</h5>
                            <p>07/05/2026 11:30</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh11}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_05.jpg</h5>
                            <p>08/05/2026 09:00</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh12}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>qd_06.jpg</h5>
                            <p>08/05/2026 14:15</p>
                        </div>
                    </div>

                </div>

            </div>

            {/* Sau bảo trì */}
            <div className="hinh-anh-section">

                <div className="hinh-anh-section-title">
                    <span className="hinh-anh-dot-green"></span>
                    Sau bảo trì (4 ảnh)
                </div>

                <div className="hinh-anh-card-wrapper">

                    <div className="hinh-anh-card">
                        <img
                            src={anh13}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>sau_01.jpg</h5>
                            <p>10/05/2026 08:30</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh14}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>sau_02.jpg</h5>
                            <p>10/05/2026 08:31</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh15}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>sau_03.jpg</h5>
                            <p>10/05/2026 08:32</p>
                        </div>
                    </div>

                    <div className="hinh-anh-card">
                        <img
                            src={anh16}
                            alt=""
                        />

                        <div className="hinh-anh-card-content">
                            <h5>sau_04.jpg</h5>
                            <p>10/05/2026 08:33</p>
                        </div>
                    </div>

                </div>

            </div>

        </div>

                    </div>



                {/* Hình ảnh */}































            </div>
        );
    }

export default HaTang;